module.exports = __webpack_public_path__ + "img/mobile/Menus-paytable/fs_title@1x.png?1.0.17";